import script from "./ReportDataBoardView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDataBoardView.vue?vue&type=script&setup=true&lang=js"

import "./ReportDataBoardView.vue?vue&type=style&index=0&id=6f3e2452&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f3e2452"]])

export default __exports__